import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select-v3';

import { reactSelectStyles } from 'utils/style';

import { getFilteredRoutes } from 'reselects';

import { isLocalOrCorridorAndDefinedAndEnabled } from 'reselects/routes';

const t = {
  placeholder: 'Select route',
};

const FILTER_FIELD = 'route';

const RouteFilter = ({ width, filters, onChange }) => {
  const routes = useSelector((state) =>
    getFilteredRoutes(state, isLocalOrCorridorAndDefinedAndEnabled)
  );

  const options = routes.map((route) => ({
    label: route.simple_name,
    value: route.simple_name,
  }));

  const handleChange = useCallback(
    ({ value }) => {
      if (!onChange) {
        return;
      }

      onChange({ [FILTER_FIELD]: value });
    },
    [onChange]
  );

  const { [FILTER_FIELD]: value } = filters || {};

  const selectValue = options.find((option) => option.value === value);

  return (
    <div className="filter" style={{ width }}>
      <Select
        value={selectValue}
        closeMenuOnSelect
        options={options}
        onChange={handleChange}
        styles={reactSelectStyles}
        placeholder={t.placeholder}
      />
    </div>
  );
};

export default RouteFilter;
